"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableSchema = void 0;
var receivable_1 = require("./receivable");
Object.defineProperty(exports, "ReceivableSchema", { enumerable: true, get: function () { return receivable_1.ReceivableSchema; } });
//# sourceMappingURL=index.js.map